import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  ArrowDownIcon,
  ArrowUpIcon,
  BoxIconLine,
  GroupIcon,
} from "../../icons";
import Badge from "../ui/badge/Badge";
import { checkAuth, getAllCustomers, emptyReduxUser } from "../../actions/userAction";
import { useNavigate } from 'react-router-dom';
import { logout } from '../../helpers/userAuth';

export default function EcommerceMetrics() {

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [customercount, setCustomerCount] = useState(0);

  const getAllCustomerRes = useSelector(state => state.userReducer.getAllCustomer);
  
  const getAllCustomerFailed = useSelector(state => state.userReducer.getAllCustomerFailed);

  const checkAuthFailed = useSelector(state => state.userReducer.checkAuthFailed);

    useEffect(() => {
      dispatch(checkAuth());
      dispatch(getAllCustomers());
    }, []);


    useEffect(() => {
      console.log("Logged out error");
      if(checkAuthFailed.statusCode == 401){
        dispatch(emptyReduxUser());
        logout();
        navigate("/signin");
      }

    }, [checkAuthFailed]);

  useEffect(() => {
    if (getAllCustomerRes) {
      if (getAllCustomerRes.statusCode == 200) {
        setCustomerCount(getAllCustomerRes.data.count);
      } else {
        console.log("Error in getting all customers");
      }
    }
  }
  , [getAllCustomerRes]); 
  useEffect(() => {
    if (getAllCustomerFailed) {
      if (getAllCustomerFailed.statusCode == 401) {
        dispatch(emptyReduxUser());
        logout();
        navigate("/signin");
      } else {
        console.log("Error in getting all customers");
      }
    }
  }, [getAllCustomerFailed]);
  
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-6">
      {/* <!-- Metric Item Start --> */}
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
        <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
          <GroupIcon className="text-gray-800 size-6 dark:text-white/90" />
        </div>

        <div className="flex items-end justify-between mt-5">
          <div>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Customers
            </span>
            <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
              {customercount?.toLocaleString() ?? 0}
            </h4>
          </div>
          <Badge color="success">
            <ArrowUpIcon />
            11.01%
          </Badge>
        </div>
      </div>
      {/* <!-- Metric Item End --> */}

      {/* <!-- Metric Item Start --> */}
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
        <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
          <BoxIconLine className="text-gray-800 dark:text-white/90" />
        </div>
        <div className="flex items-end justify-between mt-5">
          <div>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              Transactions
            </span>
            <h4 className="mt-2 font-bold text-gray-800 text-title-sm dark:text-white/90">
              5,359
            </h4>
          </div>

          <Badge color="error">
            <ArrowDownIcon />
            9.05%
          </Badge>
        </div>
      </div>
      {/* <!-- Metric Item End --> */}
    </div>
  );
}
